(ns pfo.flash (:require [pfo.state :as state]))

(def $ js/$)

(defn set-flash [flash-type message]
  (reset! state/flash {:type flash-type :message message :active true})
  (js/setTimeout (fn []
                   (.fadeOut ($ "#flash") 400)
                   (js/setTimeout #(reset! state/flash {}) 400)) 8000))

(defn flash []
 (when (:active @state/flash)
        [:div#flash {:class (str "flash-" (name (:type @state/flash)))}
         (:message @state/flash)
         [:span.close {:on-click #(.fadeOut ($ "#flash") 400)} "×"]]))
